import axios from 'axios';

const normalizeApiEnvelope = (response: any) => {
   const payload = response?.data;
   const nested = payload?.data;
   if (!payload || typeof payload !== 'object' || !nested || typeof nested !== 'object' || Array.isArray(nested)) {
      return response;
   }

   return {
      ...response,
      data: {
         ...payload,
         ...nested,
      }
   };
}

export const postRequest = async( url?: any, data?: any) => {
   // console.log('url', url);
   // console.log('data', data);
   const result = await axios.post(url, data)
   .then((response) => normalizeApiEnvelope(response))
   .catch((error) => error.response);
   return result;
}

export const postRequest2 = async(url:any, data:any) => {
   // console.log('url', url);
   console.log('data', data);
   const result = await axios.post(url, data, {
      headers: {
         Authorization: `Bearer ${localStorage.getItem('token')}`,
         'Content-Type': 'application/json',
      }
   }).then((response) => normalizeApiEnvelope(response))
      .catch((error) => error.response)
   return result;
}
